import { render, staticRenderFns } from "./events.vue?vue&type=template&id=0da82e90&scoped=true&"
import script from "./events.vue?vue&type=script&lang=js&"
export * from "./events.vue?vue&type=script&lang=js&"
import style0 from "./events.vue?vue&type=style&index=0&id=0da82e90&prod&lang=less&scoped=true&"
import style1 from "./events.vue?vue&type=style&index=1&id=0da82e90&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da82e90",
  null
  
)

export default component.exports